import { render } from "./map.vue?vue&type=template&id=5e54d084"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"

import "./map.vue?vue&type=style&index=0&id=5e54d084&lang=less"
script.render = render

export default script